import type { CharacterState } from './character-state';

export const TransitionReason = {
  BATTLE_RESET: 'BATTLE_RESET',
  INPUT_HELD: 'INPUT_HELD',
  INPUT_BUFFERED: 'INPUT_BUFFERED',
  SYSTEM_REQUEST: 'SYSTEM_REQUEST',
  HITSTOP_RESUME: 'HITSTOP_RESUME',
  GROUND_LANDING: 'GROUND_LANDING',
  AIRBORNE_HITSTUN_LANDING: 'AIRBORNE_HITSTUN_LANDING',
  COMBAT_HIT: 'COMBAT_HIT',
  COMBAT_GUARD: 'COMBAT_GUARD',
  COMBAT_COUNTER: 'COMBAT_COUNTER',
  ATTACK_STARTED: 'ATTACK_STARTED',
  STUN_COMPLETE: 'STUN_COMPLETE',
  WAKE_COMPLETE: 'WAKE_COMPLETE',
  ROUND_KO: 'ROUND_KO',
} as const;

export type TransitionReason = (typeof TransitionReason)[keyof typeof TransitionReason];

export interface TransitionRequest {
  readonly target: CharacterState;
  readonly reason: TransitionReason;
}

export interface AcceptedTransition extends TransitionRequest {
  readonly from: CharacterState;
}
